import LoanForm from './LoanForm';

export default LoanForm;
